import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { departmentApi, Department } from '../services/recruitingApi';

export interface DepartmentCreate {
  name: string;
  parent_id?: string;
  head_user_id?: string;
}

export const departmentKeys = {
  all: ['ats-departments'] as const,
  list: () => [...departmentKeys.all, 'list'] as const,
};

export function useDepartments() {
  return useQuery({
    queryKey: departmentKeys.list(),
    queryFn: () => departmentApi.list(),
  });
}

export function useCreateDepartment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: DepartmentCreate): Promise<Department> => departmentApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: departmentKeys.all });
    },
  });
}
